import React, { useState } from 'react';
import { WeightSelector } from './WeightSelector';
export const DosageGuide = () => {
  const [selectedDosage, setSelectedDosage] = useState('1 chew');
  const weightOptions = [{
    id: 'small',
    label: 'Under 25 lbs',
    value: '1/2 chew'
  }, {
    id: 'medium',
    label: '25-50 lbs',
    value: '1 chew'
  }, {
    id: 'large',
    label: '50-75 lbs',
    value: '1.5 chews'
  }, {
    id: 'xlarge',
    label: 'Over 75 lbs',
    value: '2 chews'
  }];
  return <div className="w-full bg-amber-100 py-12 DosageGuide" data-id="element-43">
      <div className="max-w-6xl mx-auto px-4 md:px-8" data-id="element-44">
        <h2 className="text-2xl font-bold text-green-900 text-center mb-8" data-id="element-45">
          How Much Does Your Dog Weigh?
        </h2>
        <p className="text-center text-gray-700 mb-8 max-w-3xl mx-auto" data-id="element-46">
          The Daily Foundation Chew™ is formulated for optimal results based on
          your dog's size:
        </p>
        <WeightSelector options={weightOptions} onSelect={setSelectedDosage} data-id="element-47" />
        <div className="bg-white rounded-lg p-6 shadow-md text-center mb-8 max-w-md mx-auto" data-id="element-48">
          <h3 className="font-bold text-green-900 mb-2" data-id="element-49">Recommended Dosage:</h3>
          <p className="text-2xl text-green-800" data-id="element-50">{selectedDosage}</p>
        </div>
        <p className="text-center text-gray-500 italic mb-8" data-id="element-51">
          Each chew is scored for easy breaking
        </p>
        <div className="text-center" data-id="element-52">
          <button className="bg-amber-600 text-white font-semibold py-3 px-8 rounded-full hover:bg-amber-500 transition" onClick={() => {
          window.open('https://snoutyco.com/products/the-daily-foundation-chew', '_blank');
        }} data-id="element-53">
            Get The Right Dosage
          </button>
        </div>
      </div>
    </div>;
};